import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { applyFavicon } from "./utils/favicon";
applyFavicon();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-504" data-mp="21cahmb8s0hiy" />);
}